module.exports = __webpack_public_path__ + "img/SEJ enventos_hora.80f07791.svg";